type WizardPageConfig = {
  target: string;
  placement: 'top' | 'bottom' | 'left' | 'right';
  translationKey: string;
  arrowTarget?: string;
};

type WizardConfig = {
  enabled: boolean;
  steps: WizardPageConfig[];
  key?: string; 
};

type WizardConfigs = {
  [page: string]: WizardConfig;
};

export const wizardConfigs: WizardConfigs = {
  'dashboard-inexperienced': {
    enabled: true,
    key: 'dashboard',
    steps: [
      {
        target: '[data-profile-avatar]',
        placement: 'bottom',
        translationKey: 'profile',
      },
      {
        target: '[data-footer-nav]',
        arrowTarget: '[data-footer-records]',
        placement: 'top',
        translationKey: 'records',
      },
      {
        target: '[data-footer-nav]',
        arrowTarget: '[data-footer-family]',
        placement: 'top',
        translationKey: 'family',
      },
      {
        target: '[data-fab-button]',
        placement: 'top',
        translationKey: 'fab',
      },
    ],
  },
  'dashboard-experienced': {
    enabled: true,
    key: 'dashboard',
    steps: [
      {
        target: '[data-profile-avatar]',
        placement: 'bottom',
        translationKey: 'profile',
      },
      {
        target: '[data-footer-nav]',
        arrowTarget: '[data-footer-records]',
        placement: 'top',
        translationKey: 'records',
      },
      {
        target: '[data-footer-nav]',
        arrowTarget: '[data-footer-family]',
        placement: 'top',
        translationKey: 'family',
      },
      {
        target: '[data-fab-button]',
        placement: 'top',
        translationKey: 'fab',
      },
    ],
  },
  'documents': {
    enabled: true,
    key: 'documents',
    steps: [
      {
        target: '[data-profile-picker-row]',
        placement: 'bottom',
        translationKey: 'profilePicker',
      },
      {
        target: '[data-search-bar]',
        placement: 'bottom',
        translationKey: 'searchBar',
      },
      {
        target: '[data-shortcuts-button]',
        placement: 'bottom',
        translationKey: 'shortcuts',
      },
      {
        target: '[data-upload-history]',
        placement: 'bottom',
        translationKey: 'uploadHistory',
      },
      {
        target: '[data-health-memories-card]',
        placement: 'top',
        translationKey: 'healthMemories',
      },
      {
        target: '[data-health-summary-card]',
        placement: 'top',
        translationKey: 'healthSummary',
      },
      {
        target: '[data-emergency-card]',
        placement: 'top',
        translationKey: 'emergencyCard',
      },
    ],
  },
  'family-owner': {
    enabled: true,
    key: 'family',
    steps: [
      {
        target: '[data-add-member-button]',
        placement: 'bottom',
        translationKey: 'addMember',
      },
      {
        target: '[data-family-notes-button]',
        placement: 'bottom',
        translationKey: 'familyNotes',
      },
    ],
  },
  'family-member': {
    enabled: true,
    key: 'family',
    steps: [
      {
        target: '[data-family-notes-button]',
        placement: 'bottom',
        translationKey: 'familyNotes',
      },
    ],
  },
  'reminders': {
    enabled: true,
    key: 'reminders',
    steps: [
      {
        target: '[data-profile-picker-row]',
        placement: 'bottom',
        translationKey: 'profilePicker',
      },
    ],
  },
  'profile': {
    enabled: true,
    key: 'profile',
    steps: [
      {
        target: '[data-profile-picker-trigger]',
        placement: 'bottom',
        translationKey: 'profilePicker',
      },
      {
        target: '[data-profile-basic-information]',
        placement: 'bottom',
        translationKey: 'basicInformation',
      },
      {
        target: '[data-profile-health-profile]',
        placement: 'bottom',
        translationKey: 'healthProfile',
      },
    ],
  },
};
